import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//Components
import LoanRow from './Loan.constants';
import Layout from '../common/Layout';
import Wrapper from '../common/Wrapper';
import SearchForm from '../common/Search/SearchForm';
import TableHeader from '../common/Table/TableHeader';
import Loading from '../common/Loading';
import { useSyles } from '../common/Wrapper/styles';
//Material
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllLoans } from '../../redux/loans/thunks';
import { fieldsFilterList, headCellsLoans, valuesEstatus } from './constants';
import useScan from '../../hooks/useScan';
import { stableSort } from 'src/helpers/sorts';
import { RolePermissions } from 'src/domain/constants/RolePremissions';
import { SystemActions } from 'src/domain/constants/SystemActions';
import { useAppSelector } from 'src/redux/hooks';
import { RootState } from 'src/domain/models/RootState';

const Loans = (props: any) => {
  const classes = useSyles();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate(); // habilitar navigate para redirección
  const { setDestination } = useScan();
  const [firstLoad, setFirstLoad] = useState(true);
  const [filter, setFilter] = useState('');
  const { auth } = useAppSelector((state: RootState) => state);
  const { selectedWarehouse } = useSelector((state: any) => state.warehouses);
  const allowCreate = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.create_loans
  );
  const allowReadAll = RolePermissions.allowed(
    auth.type,
    SystemActions.read_loans
  );
  // obtener el state
  const fieldsFilterListPermision = fieldsFilterList.filter((item) => {
    return item.key != 'users_id' || allowReadAll;
  });
  const initialValuesFilter = {
    key: allowReadAll ? 'users_id' : fieldsFilterListPermision[0].key,
    name_value: '',
  };
  const { loans, loading } = useSelector((state: any) => state.loans);
  const [pagination, setPagination] = useState({
    rowsPerPage: 10,
    page: 1,
    total: 1,
    order: 'desc',
    orderBy: 'name',
  });
  useEffect(() => {
    setDestination('act-l-loa', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateDataByPagination = async () => {
    await dispatch(getAllLoans({ filter, pagination }));
  };

  useEffect(() => {
    pagination.page = 1;
    updateDataByPagination();
    setFirstLoad(false);
    // eslint-disable-next-line
  }, [filter, selectedWarehouse]);

  useEffect(() => {
    setPagination({
      ...pagination,
      total: loans.paginate?.items ? loans.paginate.items : 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loans.paginate]);

  useEffect(() => {
    if (!firstLoad) {
      updateDataByPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.rowsPerPage, pagination.page]);
  // función que redirige de forma programada
  const redirectAdd = () => {
    navigate(`/loans/new`, { replace: true });
  };
  //Tabla
  const emptyRows =
    pagination.rowsPerPage -
    Math.min(
      pagination.rowsPerPage,
      pagination.total - pagination.page * pagination.rowsPerPage
    );
  const { order, orderBy } = props;

  const handleChangePage = (event: any, page: any) => {
    setPagination({
      ...pagination,
      page: ++page,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      rowsPerPage: event.target.value,
    });
  };

  const getSorting = (order: string, orderBy: any) => {
    return order === 'desc'
      ? (a: any, b: any) => desc(a, b, orderBy)
      : (a: any, b: any) => -desc(a, b, orderBy);
  };

  const desc = (a: any, b: any, orderBy: any) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };
  //Fin de tabla

  // cuando el usuario haga submit en el formulario de busqueda
  const submitFilterLoans = (values: any) => {
    //preparar la data para filtrar
    if (values.key !== '' && values.name_value !== '') {
      setFilter(`&${values.key}=${values.name_value}`);
    } else {
      setFilter('');
    }
  };
  const sliceX = 0;
  const sliceY = pagination.rowsPerPage;
  //Fin de los filtros
  return (
    <Layout>
      <Wrapper
        button={allowCreate}
        buttonTitle='Realizar prestamo'
        actionTitle={() => allowCreate && redirectAdd()}
      >
        <Grid className={classes.containerHeader} container item spacing={4}>
          <Grid item xs={12} sm={8} md={8} className={classes.button}>
            <SearchForm
              submitFilter={submitFilterLoans}
              fields={fieldsFilterListPermision}
              initialValues={initialValuesFilter}
              filter={'LOA'}
              valuesEstatus={valuesEstatus}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} className={classes.button}>
            {allowCreate && (
              <Button
                size='medium'
                color='secondary'
                variant='contained'
                onClick={() => redirectAdd()}
              >
                Realizar prestamo
                <Add />
              </Button>
            )}
          </Grid>
        </Grid>
        {!loading ? (
          <div>
            <div>
              <TableContainer component={Paper}>
                <Table aria-label='simple table'>
                  <TableHeader cellsList={headCellsLoans} />
                  <TableBody>
                    {stableSort(loans.loans, getSorting(order, orderBy))
                      .slice(sliceX, sliceY)
                      .map((loan: any) => {
                        return (
                          <LoanRow key={`key-row-${loan.id}`} loan={loan} />
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 49 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component='div'
              count={pagination.total}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page - 1}
              labelRowsPerPage='Renglones por página'
              backIconButtonProps={{
                'aria-label': 'Anterior',
              }}
              nextIconButtonProps={{
                'aria-label': 'Siguiente',
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <Loading />
        )}
      </Wrapper>
    </Layout>
  );
};

export default Loans;
